import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';


import { JackpotSymbolImages, JackpotSymbolNames, T } from '../../../../../constants';
import { dotFormatter, setTranslationValues } from '../../../../../helpers';
import { useStore, useTranslation } from '../../../../../hooks';

import JackpotPopupLogo from '../../../../../assets/media/jackpot/logo.png';

interface JackpotWinPopupProps {

}

export const JackpotWinPopup: React.FC<JackpotWinPopupProps> = observer(() => {

  const { jackpotStore, gameStore } = useStore();
  const { winPopupData } = jackpotStore;
  const { currencySymbol } = gameStore;

  const t = useTranslation();

  const closeWinPopup = useCallback(() => {
    jackpotStore.resetWinPopupData();
  }, []);
  
  const congratsText = useMemo(() => {
    if (!winPopupData) return null;
    return setTranslationValues(
      t(T.JACKPOT_WIN_CONGRATULATIONS),
      { tier: t(JackpotSymbolNames[winPopupData.name]) }
    );
  }, [t, winPopupData]);

  if (!winPopupData) return null;

  const { name: tierName, winAmount } = winPopupData;

  return (
    <div className="jackpot-popup-holder">
      <div className="jackpot-popup">
        <img
          alt={tierName}
          className="jackpot-popup-win-type"
          src={JackpotSymbolImages[tierName]}
        />
        <img
          alt="popup-logo"
          src={JackpotPopupLogo}
          className="jackpot-popup-logo"
        />
        <p className="jackpot-popup-txt">
          { congratsText }
        </p>
        <div className="jackpot-popup-win-amount">
          <span>{currencySymbol} {dotFormatter(winAmount, 2)}</span>
        </div>
        <button
          onClick={closeWinPopup}
          className="jackpot-popup-btn"
        >
          { t(T.CONTINUE) }
        </button>
      </div>
    </div>
  );
});
